module.exports = __webpack_public_path__ + "static/media/arrows.d8868563.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrows.svg
// module id = 207
// module chunks = 21